// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchTextField, { SearchTextFieldStyles } from "@insite/content-library/Widgets/OrderHistory/SearchTextField";
import * as React from "react";
import { connect } from "react-redux";

// Xng-Changes
const mapStateToProps = (state: ApplicationState) => {
    return {
        parameter: state.pages.orderHistory.incompleteGetOrdersParameter,
    };
};

export const orderTotalStyles: SearchTextFieldStyles = {};

const styles = orderTotalStyles;

// Xng-Changes
type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const OrderHistorySearchFieldOrderTotal: React.FunctionComponent<Props> = ({ parameter }) => {
    // Xng-Changes
    const operatorValue = parameter?.orderTotalOperator || "";

    return (
        <SearchTextField
            testSelector="orderHistory_filterOrderTotal"
            styles={styles}
            parameterField="orderTotal"
            label="Amount"
            inputType="number"
            placeholder=""
            // Xng-Changes
            {...{ disabled: !operatorValue }}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderHistorySearchFieldOrderTotal),
    definition: {
        group: "Order History",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
        displayName: "Order Total",
    },
};

export default widgetModule;
